import { render, staticRenderFns } from "./GPaymentStatusChip.vue?vue&type=template&id=99dc0a90&scoped=true"
import script from "./GPaymentStatusChip.vue?vue&type=script&lang=js"
export * from "./GPaymentStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dc0a90",
  null
  
)

export default component.exports